import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Snackbar from "../../Snacbar";
import HashLoader from "react-spinners/HashLoader";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import OperationReportService from "../../../Services/Reports/OperationReportService";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(61, 195, 177)",
    color: "black",
    textAlign: "center",
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  border: " 1px solid black",
}));
function JobReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",
    fontFamily: "Times New Roman",
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: "Times New Roman",
  };

  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");
  const [loading, setloading] = useState(false);
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [data, setData] = useState([]);
  const [cusWseValues, setcusWseValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: "-1",
    importer: "-1",
    operation: "IMPORTER",
    clearecestatus: "-1",
    cl_from_date: getDate(),
    Cl_to_date: getDate(),
  });
  const headers = [
    { label: "S.No", key: "serialNumber" },
    { label: "Consignemt No", key: "consignemtNo" },
    { label: "Branch", key: "branch" },
    { label: "Clearance Port", key: "clearanceport" },
    { label: "Party", key: "partyName" },
    { label: "BE No", key: "be_no" },
    { label: "SB Date", key: "sb_date" },
    { label: "Total Container", key: "total_container" },
    { label: "Bill Amount", key: "billAmount" },
    { label: "Bill No", key: "billNo" },
    { label: "Operation Type", key: "operation_type" },
  ];

  const fromhandlechange = (e) => {
    setcusWseValues({ ...cusWseValues, from: e.target.value });
  };
  const tohandlechange = (e) => {
    setcusWseValues({ ...cusWseValues, to: e.target.value });
  };
  const branchhandlechange = (e) => {
    setcusWseValues({
      ...cusWseValues,
      branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const importerhandlechange = (e) => {
    setcusWseValues({
      ...cusWseValues,
      importer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const operationhandlechange = (e) => {
    setcusWseValues({
      ...cusWseValues,
      operation: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const clearencehandlechange = (e) => {
    setcusWseValues({
      ...cusWseValues,
      clearecestatus: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fromclrhandlechange = (e) => {
    setcusWseValues({ ...cusWseValues, cl_from_date: e.target.value });
  };
  const toclrhandlechange = (e) => {
    setcusWseValues({ ...cusWseValues, Cl_to_date: e.target.value });
  };
  ///
  const [showProcs, setshowProcs] = useState(false);
  const [refreshProcs, setrefreshProcs] = useState(false);
  const [pdfexportProcs, setpdfexportProcs] = useState(false);
  const [excelexportProcs, setexcelexportProcs] = useState(false);
  //error message
  const handleClose = () => {
    setOpen(false);
  };
  //validation
  const validation = () => {
    if (cusWseValues.importer !== "") {
      return true;
    } else {
      setMessage("Kindly select the Importer Name");
      setseverit("warning");
      setOpen(true);
      document.getElementById("impid").focus();
      setloading(false);
      setshowProcs(false);
    }
    return false;
  };
  // getfunction//////
  const getbranch = () => {
    BillingReportsService.getRegionalOfficeDetails().then((res) => {
      setdetails1(res.data);
    });
  };
  const getimporter = () => {
    OperationReportService.getCustomLocation().then((res) => {
      setdetails2(res.data);
    });
  };
  //button Operation
  const showBtnClick = () => {
    setloading(true);
    setshowProcs(true);
    setPage(0);
    if (validation() === true) {
      let details = {
        fromDate: cusWseValues.from,
        toDate: cusWseValues.to,
        custom_pointId: cusWseValues.importer,
        operation_type: cusWseValues.operation,
        branchId: cusWseValues.branch,
        clearance_status: cusWseValues.clearecestatus,
        cl_from_date: cusWseValues.cl_from_date,
        Cl_to_date: cusWseValues.Cl_to_date,
      };
      console.log("details==>" + JSON.stringify(details));
      BillingReportsService.jobDetails(details).then((res) => {
        if (res.data === []) {
          setMessage("No Data Found");
          setseverit("warning");
          setOpen(true);
          setloading(false);
          setshowProcs(false);
        } else {
          setdetails3(res.data);
          setData(res.data);
          setloading(false);
          setshowProcs(false);
        }
      });
    }
  };
  const refreshBtnClick = () => {
    setPage(0);
    setrefreshProcs(true);
    setcusWseValues({
      ...cusWseValues,
      from: getDate(),
      to: getDate(),
      branch: "-1",
      importer: "-1",
      operation: "IMPORTER",
      clearecestatus: "-1",
    });
    setdetails3([]);
    setrefreshProcs(false);
    setshowProcs(false);
  };
  const exp_pdfBtnClick = () => {
    setpdfexportProcs(true);
    if (validation() === true) {
      let details = {
        fromDate: cusWseValues.from,
        toDate: cusWseValues.to,
        iecNo: cusWseValues.importer,
        oprType: cusWseValues.operation,
        branchId: cusWseValues.branch,
      };
      BillingReportsService.billDetails_report(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank");
        window.open(
          "http://35.154.221.117:8081/ExportFiles/" + filename.toString(),
          "_blank"
        );
      });
    }
    setpdfexportProcs(false);
  };
  const exp_excelBtnClick = () => {
    setexcelexportProcs(true);
    if (!details3[0]) {
      setMessage("Datagrid Should not be empty");
      setseverit("warning");
      setOpen(true);
    } else {
      var tableContent,
        contenall = "";
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].iecName !== "") {
          tableContent += details3[i].iecName + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].jobNo !== "") {
          tableContent += details3[i].jobNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].mawbNo !== "") {
          tableContent += details3[i].mawbNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].boeNo !== "") {
          tableContent += details3[i].boeNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].lgRefNo !== "") {
          tableContent += details3[i].lgRefNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].billPaidDate !== "") {
          tableContent += details3[i].billPaidDate + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].agency_chr !== "") {
          tableContent += details3[i].agency_chr + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].airport_chr !== "") {
          tableContent += details3[i].airport_chr + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].document_chr !== "") {
          tableContent += details3[i].document_chr + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].cfs_chr !== "") {
          tableContent += details3[i].cfs_chr + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].transport_chr !== "") {
          tableContent += details3[i].transport_chr + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].do_chr !== "") {
          tableContent += details3[i].do_chr + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].cgstAmt !== "") {
          tableContent += details3[i].cgstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].sgstAmt !== "") {
          tableContent += details3[i].sgstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details3[i].igstAmt !== "") {
          tableContent += details3[i].igstAmt + "#";
        } else {
          tableContent += "  #";
        }
        contenall += tableContent;
      }
      let details = {
        headerName: "3,0,CUSTOMER WISE BILL DETAILS REPORT",
        headerDetails:
          "1,1,FROM DATE : " +
          cusWseValues.from +
          "/4,1,TO DATE : " +
          cusWseValues.to,
        tableHeader:
          "0,3,Sl.No/1,3,Importer Name/2,3,Job No/3,3,AWB No/4,3,BOE No/5,3,Ref No/6,3,Date/7,3,Agency Charge/8,3,Airport Charge/9,3,Document Charge/10,3,CFS Charge/11,3,Transport Charge/12,3,DO Charge/13,3,CGST Amt/14,3,SGST Amt/15,3,IGST Amt",
        tableRowStartsFrom: 4,
        tableColumnStartsFrom: 0,
        fileCode: "Customer_bill_report",
        totalNumberOfColumn: 16,
        tableContent: contenall.substring(0, contenall.length - 1),
      };
      BillingReportsService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open(
          "http://35.154.221.117:8081/ExportFiles/" + filename.toString(),
          "_blank"
        );
      });
    }
    setexcelexportProcs(false);
  };

  const exportToExcel = () => {
    if (details3.length === 0) {
      alert("No data to export!");
      return;
    }

    // Map and rename fields
    const mappedData = details3.map((item) => {
      const row = {};
      headers.forEach((h) => {
        row[h.label] = item[h.key]; // Use header label as Excel column name
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedData, {
      header: headers.map((h) => h.label),
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Job Details");

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Job-Details.xlsx");
  };

  //
  useEffect(() => {
    setloading(true);
    setTimeout(() => {
      setloading(false);
    }, 1000);
    getbranch();
    getimporter();
  }, []);

  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div>
      <Snackbar
        open={open}
        message={message}
        severity={severit}
        onClose={handleClose}
      />
      <Home />
      <div style={{ paddingLeft: "80px" }}>
        {loading ? (
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <ItemPap>
            <div
              className="Billingtitleclr"
              style={{
                fontFamily: "Times New Roman",
                color: "red",
                fontWeight: "bold",
                fontSize: "25px",
                marginTop: "1%",
                marginBottom: "1%",
              }}
            >
              <center> JOB DETAILS </center>
            </div>
            <Row>
              <Col>
                <center>
                  <label style={mystyle1}>From Date</label>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={cusWseValues.from}
                    onChange={fromhandlechange}
                  />
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>To Date</label>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={cusWseValues.to}
                    onChange={tohandlechange}
                  />
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>Clearance From Date</label>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={cusWseValues.cl_from_date}
                    onChange={fromclrhandlechange}
                  />
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>Clearance To Date</label>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={cusWseValues.Cl_to_date}
                    onChange={toclrhandlechange}
                  />
                </center>
              </Col>
            </Row>
            <Row>
              <Col>
                <center>
                  <label style={mystyle1}>Branch</label>
                  <Form.Select
                    size="sm"
                    style={mystyle}
                    value={cusWseValues.branch}
                    onChange={branchhandlechange}
                  >
                    {details1.map((trns) => (
                      <option
                        value={trns.regionalOfficeId}
                        key={trns.regionalOfficeId}
                      >
                        {trns.regionalName}
                      </option>
                    ))}
                  </Form.Select>
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>Clearance Status</label>
                  <Form.Select
                    size="sm"
                    style={mystyle}
                    value={cusWseValues.clearecestatus}
                    onChange={clearencehandlechange}
                  >
                    <option value={"-1"}>ALL</option>
                    <option value={"yes"}>YES</option>
                    <option value={"no"}>NO</option>
                  </Form.Select>
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>Clearance Port</label>
                  <Form.Select
                    type="text"
                    id="impid"
                    list="code"
                    style={mystyle}
                    size="sm"
                    value={cusWseValues.importer}
                    onChange={importerhandlechange}
                  >
                    <option value="-1">ALL</option>
                    {details2.map((trns) => (
                      <option
                        value={trns.clearanceLocationCode}
                        key={trns.serialNumber}
                      >
                        {trns.clearanceLocationName}
                      </option>
                    ))}
                  </Form.Select>
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>OperationType</label>
                  <Form.Select
                    size="sm"
                    style={mystyle}
                    value={cusWseValues.operation}
                    onChange={operationhandlechange}
                  >
                    {/* <option value={"-1"}>ALL</option> */}
                    <option value={"IMPORTER"}>IMPORT</option>
                    <option value={"EXPORTER"}>EXPORT</option>
                    {/* <option value={"COURIER"}>COURIER</option> */}
                  </Form.Select>
                </center>
              </Col>
            </Row>
            <br></br>
            <Row className="mb-1">
              <Col lg={3}></Col>
              <Col lg={6}>
                <Button
                  style={{ fontFamily: "Times New Roman" }}
                  variant="primary"
                  size="sm"
                  onClick={showBtnClick}
                >
                  {" "}
                  {showProcs ? "processing..." : "Show"}
                </Button>
                &nbsp;
                {/* <Button
                  style={{ fontFamily: "Times New Roman" }}
                  variant="secondary"
                  size="sm"
                  onClick={refreshBtnClick}
                >
                  {refreshProcs ? "processing..." : "Refresh"}{" "}
                </Button>
                &nbsp;
                <Button
                  style={{ fontFamily: "Times New Roman" }}
                  variant="success"
                  size="sm"
                  onClick={exp_pdfBtnClick}
                >
                  {" "}
                  {pdfexportProcs ? "processing..." : "Export-PDF"}{" "}
                </Button>
                &nbsp; */}
                <Button
                  style={{ fontFamily: "Times New Roman" }}
                  variant="success"
                  size="sm"
                  onClick={exportToExcel}
                >
                  {excelexportProcs ? "processing..." : "Export-Excel"}
                </Button>
              </Col>
              <Col lg={3}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 420 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>S.No</StyledTableCell>
                      <StyledTableCell>Consignemt No</StyledTableCell>
                      <StyledTableCell>Branch</StyledTableCell>
                      <StyledTableCell>Clearance Date</StyledTableCell>
                      <StyledTableCell>Clearance Port</StyledTableCell>
                      <StyledTableCell>Party</StyledTableCell>
                      <StyledTableCell>BE No</StyledTableCell>
                      <StyledTableCell>SB Date</StyledTableCell>
                      <StyledTableCell>Total Container</StyledTableCell>
                      <StyledTableCell>Bill Amount</StyledTableCell>
                      <StyledTableCell>Bill No</StyledTableCell>
                      <StyledTableCell>Operation Type</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {details3
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.consignemtNo}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.branch}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.clearance_date}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.clearanceport}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.partyName}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.be_no}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.sb_date}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.total_container}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.billAmount}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.billNo}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ fontSize: "10px", fontWeight: "bold" }}
                          >
                            {trns.operation_type}
                          </StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component="div"
                count={details3.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>
        )}
      </div>
    </div>
  );
}

export default JobReport;
